import { createContext, useContext, useMemo } from "react";
import { useUser } from "../api/useAuth";
import { buildDashboardAccess, normalizeRoleId } from "./nativeDashboardsAccess";
import { DashboardAccess, NativeDashboardRecord } from "./types";

// Default fora de um dashboard montado pelo NativeDashboards: sem drill (fail-closed) e sem filtros.
const DEFAULT_ACCESS: DashboardAccess = {
    dashboardKey: "",
    dataScope: "user",
    transport: "viewer",
    canDrill: false,
    viewerParams: {},
    viewerRuleMissing: false,
};

const DashboardAccessContext = createContext<DashboardAccess>(DEFAULT_ACCESS);

export const useDashboardAccess = () => {
    const access = useContext(DashboardAccessContext);
    return access;
};

type DashboardAccessProviderProps = {
    record: NativeDashboardRecord;
    children: React.ReactNode;
};

export const DashboardAccessProvider = ({ record, children }: DashboardAccessProviderProps) => {
    const userResult = useUser();
    const viewerRoleId = normalizeRoleId(userResult.data?.role);
    const access = useMemo(() => buildDashboardAccess(record, viewerRoleId), [record, viewerRoleId]);

    return <DashboardAccessContext.Provider value={access}>{children}</DashboardAccessContext.Provider>;
};
